export default "__VITE_ASSET__CtWwWuf8__"